import PropTypes from "prop-types"
import { createContext } from "react"
import { useMutation, useQuery } from "react-query"
import { createLesson, listLessons } from "~/actions/lessons"

const LessonsContext = createContext()
export default LessonsContext

export const LessonsContainer = ({ children }) => {
  const createLessonMutation = useMutation(createLesson)

  const { data: lessons, isLoading: lessonsLoading } = useQuery(
    "lessons",
    listLessons,
  )

  return (
    <LessonsContext.Provider
      value={{ createLessonMutation, lessons, lessonsLoading }}
    >
      {children}
    </LessonsContext.Provider>
  )
}

LessonsContainer.propTypes = {
  children: PropTypes.node,
}
